/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import React from "react";
import { ApolloProvider } from "@apollo/client";
import CloudApolloClientProvider from "./CloudApolloClientProvider";

export interface GraphQLProviderProps {
    children: React.ReactNode | React.ReactNode[] | null;
}

export default function GraphQLProvider(props: GraphQLProviderProps) {
    return (
        <ApolloProvider client={new CloudApolloClientProvider().client.apolloClient}>
            {props.children}
        </ApolloProvider>
    );
}